import { Routes, Route, Navigate } from "react-router-dom";
import Login from "./screens/Login";
import Homepage from "./screens/Homepage";

function AppRoutes({ user, onLogin, onLogout }) {
  return (
    <Routes>
      {/* Homepage */}
      <Route
        path="/"
        element={
          user ? (
            <Homepage user={user} onLogout={onLogout} />
          ) : (
            <Navigate to="/login" replace />
          )
        }
      />

      {/* Login */}
      <Route
        path="/login"
        element={
          user ? (
            <Navigate to="/" replace />
          ) : (
            <Login onLogin={onLogin} />
          )
        }
      />
    </Routes>
  );
}

export default AppRoutes;
